import { Button, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import type { PartnerSchemaInternal } from '@mangovoice/grove-scheduler-client'

export interface IntegrationAgentAuthSectionProps {
  oauthUrl: string | null
  schema: PartnerSchemaInternal
}

/**
 * Authorization section for integration agents
 * Shows authorization button and help text for OAuth-enabled partners
 * Shows a fallback message when the schema has no OAuth URL builder
 */
export const IntegrationAgentAuthSection: React.FC<
  IntegrationAgentAuthSectionProps
> = ({ oauthUrl, schema }) => {
  const { t } = useTranslation()

  if (!oauthUrl) {
    return (
      <>
        <Text fontSize="sm" fontWeight="semibold" color="fg.default" mt={3}>
          {t('integrationsSettings.auth')}
        </Text>
        <Text color="fg.muted" fontSize="sm">
          {t('integrationsSettings.authRegionNotSupported')}
        </Text>
      </>
    )
  }

  return (
    <>
      <Text fontSize="sm" fontWeight="semibold" color="fg.default" mt={3}>
        {t('integrationsSettings.auth')}
      </Text>
      <Text color="fg.muted" fontSize="sm">
        {t('integrationsSettings.authDescription')}
      </Text>

      <Button
        asChild
        bg="brand.solid"
        color="white"
        px={5}
        py={2.5}
        borderRadius="lg"
        _hover={{
          bg: 'brand.emphasized',
          boxShadow: 'default',
        }}
      >
        <a href={oauthUrl} target="_blank" rel="noopener noreferrer">
          {t('integrationsSettings.authButton')}
        </a>
      </Button>

      {schema.authHelp && (
        <Text color="fg.muted" fontSize="sm" mt={2}>
          {schema.authHelp}
        </Text>
      )}
    </>
  )
}
